import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from 'app/components/NotFoundPage';
import MainLayout from 'app/components/layouts/MainLayout';
import WidgetsPageRoute from './WidgetsPageRoute';

const basePath = '/v2/widgets';

export default (
  <Route path={basePath}>
    <MainLayout>
      <Switch>
        <Route exact path={basePath}>
          <WidgetsPageRoute />
        </Route>
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
